export const getCustomerName = state => {
  return state.customer.name;
};

export const getCellphone = state => {
  return state.customer.cell_phone;
};
